import {combineReducers} from 'redux'
import {modal, contextMenu} from "@mc/mc-legacy";
import {reducer as toastr} from 'react-redux-toastr'
import {reducer as form} from 'redux-form'
import app from "./app"

/**
 * Root definice store.
 */
export default combineReducers({
    modalDialog: modal.ModalReducer,
    contextMenu: contextMenu.reducer,
    app,
    toastr,
    form
});
